import { FBAutocompleteAsyncProps } from '..';

export const DEVIATION_SELECTED_LHRT_KEY = 'deviation-selected-lhrt';
export const DEVIATION_SERIAL_NUMBERS_KEY = 'deviation-serial-numbers';

export interface DeviationSerialNumberEntry {
  whereUsed: boolean
  serialNumbers: string[]
}

export type DeviationSerialNumbers = Array<Record<string, DeviationSerialNumberEntry>>;

export type FBAffectedLhrSelectionProps = FBAutocompleteAsyncProps & {
  isOutput?: boolean
};
